import { ReactElement, useEffect, useState } from 'react';

import { Stack, StackProps } from '@components/stack';

import { StateItemProps, StateSelector } from './state-item';

export type State = { id: string } & Pick<
  StateItemProps,
  'description' | 'orientation' | 'icon' | 'label'
>;

export type StateGroupProps<T extends State = State> = {
  label?: ReactElement;
  stateItems: T[];
  selectedStateId: T['id'];
  onStateSelected?: (state: T) => void;
  isDisabled?: boolean;
} & Pick<StackProps, 'orientation'>;

export const StateGroup = <T extends State>({
  label,
  stateItems,
  orientation,
  selectedStateId,
  onStateSelected,
  isDisabled = false,
}: StateGroupProps<T>) => {
  const [selected, setSelected] = useState(selectedStateId);
  useEffect(() => {
    if (selectedStateId) setSelected(selectedStateId);
  }, [selectedStateId]);
  return (
    <Stack space={2}>
      {label}
      <Stack orientation={orientation} space={4}>
        {stateItems.map((item) => (
          <StateSelector
            key={item.id}
            selected={item.id === selected}
            onSelected={() => {
              if (!isDisabled) {
                onStateSelected && onStateSelected(item);
                setSelected(item.id);
              }
            }}
            orientation={item.orientation}
            icon={item.icon}
            label={item.label}
            description={item.description}
            isDisabled={isDisabled}
          />
        ))}
      </Stack>
    </Stack>
  );
};
